import { Component, Input, Output, EventEmitter } from '@angular/core'

import { GroupsService } from '../../services/groups.service'
import { UsersService } from '../../services/users.service'
import { Group } from '../../models/group.model'

@Component({
  selector: 'ld-select-group-multiple',
  template: require('./select-group-multiple.component.html'),
  styles: [require('./select-group-multiple.component.css')]
})
export class SelectGroupMultipleComponent {
  @Input('active') active: Group[]
  @Output('activeChange') activeChange = new EventEmitter<Group[]>()

  constructor (
    private groupsService: GroupsService,
    private usersService: UsersService) {
    this.optionsLookup = this.optionsLookup.bind(this)
  }

  onChange (groups: Group[]) {
    this.activeChange.emit(groups)
  }

  // see: https://edcarroll.github.io/ng2-semantic-ui/#/modules/select
  async optionsLookup (query, initial?) {
    const groups = initial || await this.groupsService.get({
      userId: this.usersService.currentUser.id,
      name: query
    }, false)
    .catch(() => {
      return []
    })

    return groups.map((group) => ({ group: group, name: group.name }))
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/select-group-multiple/select-group-multiple.component.ts